import styled from "@emotion/styled";
import {
  IconButton as MuiIconButton,
  Box as MuiBox,
  styled as muiStyled,
} from "@mui/material";
import Icon from "components/Icon";
import { PageDotIndicator } from "components/SimpleRegistrations/PageDotIndicator";
import { useImperativeModal } from "~/ImperativeModalProvider";
import { ConfirmModal } from "../Modal/ConfirmModal";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 68px;
  font-weight: 500;
`;

const Box = styled(MuiBox)`
  &.alert-body {
    font-weight: bold;
  }

  &.alert-title {
    font-size: 2vw;
    margin-bottom: 5%;
  }
`;

const IconButton = muiStyled(MuiIconButton)(
  () => `
  width: 80px;
  height: 80px;
  margin: 40px 20px 0;
`
);

interface HeaderProps {
  onClose: () => void;
  onConfirm?: () => void;
  onChangePrevPage?: () => void;
  usePageIndicator?: boolean;
  page?: number;
  total?: number;
}

export const Header = ({
  onClose,
  onConfirm,
  onChangePrevPage,
  usePageIndicator = false,
  page = 0,
  total = 0,
}: HeaderProps) => {
  const imperativeModal = useImperativeModal();

  const handleBack = async () => {
    await imperativeModal.open((close) => (
      <ConfirmModal
        body={
          <Box className="alert-body">
            <Box className="alert-title">안내</Box>
            <div>
              이전 단계로 이동할까요?
              <br />
              입력중인 정보는 저장되지 않습니다.
            </div>
          </Box>
        }
        cancelText="아니오"
        confirmText="예"
        onClose={close}
        onConfirm={() => {
          if (onChangePrevPage) {
            onChangePrevPage();
          } else {
            onClose();
          }
          close();
        }}
        open={true}
      />
    ));
  };

  const handleClose = async () => {
    await imperativeModal.open((close) => (
      <ConfirmModal
        body={
          <Box className="alert-body">
            <Box className="alert-title">안내</Box>
            <div>
              진행하던 접수를 취소할까요?
              <br />
              입력중인 정보는 저장되지 않습니다.
            </div>
          </Box>
        }
        cancelText="아니오"
        confirmText="예"
        onClose={close}
        onConfirm={() => {
          onClose();
          close();
        }}
        open={true}
      />
    ));
  };

  return (
    <Wrapper>
      <IconButton onClick={onConfirm ? onConfirm : handleBack}>
        <Icon variant="simpleBack" />
      </IconButton>
      <Box>
        {usePageIndicator && <PageDotIndicator page={page} total={total} />}
      </Box>
      <IconButton onClick={handleClose}>
        <Icon variant="simpleClose" />
      </IconButton>
    </Wrapper>
  );
};
